import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFileDownload } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import modalStyle from '../styles/modal';
import Timestamp from 'react-timestamp';

Modal.setAppElement('#root');
class MessageItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            message: '',
            confirm: {
                isShow: false,
                title: '',
                message: ''
            }
        }
    }

    componentDidMount() {
        this.setState({
            message: this.props.item
        });
    }

    showConfirmModal = () => {
        this.setState({
            confirm: {
                isShow: true,
                title: 'Archivar mensaje',
                message: "Desea archivar este mensaje."
            }
        });
    }

    closeConfirmModal = (confirmed) => {
        this.setState({
            confirm: {
                isShow: false,
                title: '',
                message: ''
            }
        });
        if (confirmed) {
            this.props.handleArchive(this.props.item);
        }
    }

    render() {
        const { message, confirm } = this.state;
        const time = message.createdAt / 1000;

        return (
            <div className="col-12 mt-2">
                <div className="card bg-light">
                    <div className="m-2">
                        <div className="row justify-content-between">
                            <div className="col-auto">
                                <h6 className="card-title">
                                    <FontAwesomeIcon className="text-info" icon={faEnvelope} />
                                    <span className="ml-2">
                                        {/* {message.email} */}
                                        <a href="mailto:{message.email}">{message.email}</a>
                                    </span>
                                    <span className="text-muted ml-2" style={{ fontSize: '0.8em' }}>
                                        <FontAwesomeIcon className="mr-1" icon={faClock} />
                                        <Timestamp date={time} />
                                    </span>
                                </h6>
                            </div>
                            {(!message.archived) ?
                                <div className="col-auto">
                                    <button onClick={this.showConfirmModal} className="btn btn-sm btn-light mt-n2 mr-n2" data-toggle="tooltip" data-placement="bottom" title="Eliminar">
                                        <FontAwesomeIcon icon={faFileDownload} />
                                        <span className="ml-2">Archivar</span>
                                    </button>
                                </div>
                                :
                                <div></div>
                            }
                        </div>
                        <span className="card-text">{message.message}</span>
                    </div>
                    <div className="nav justify-content-end position-fixed">

                    </div>
                </div>

                <Modal
                    isOpen={confirm.isShow}
                    contentLabel="Modal Example"
                    style={modalStyle}
                    onRequestClose={() => this.closeConfirmModal(false)}>
                    <div className="" style={{ minWidth: '300px', maxWidth: '400px' }}>
                        <h5 className="card-title">{confirm.title}</h5>
                        <p className="card-text text-break">{confirm.message}</p>

                        <div className="nav justify-content-end">
                            <button onClick={() => this.closeConfirmModal(false)} className="btn btn-sm btn-dark">No</button>
                            <button onClick={() => this.closeConfirmModal(true)} className="btn btn-sm btn-dark ml-2">Si</button>
                        </div>
                    </div>

                </Modal>
            </div>


        );
    }
}

export default MessageItem;